<ng-container [formGroup]="form">
	<rpshared-field-manager-link
		required
		formControlName="fieldManager"
	></rpshared-field-manager-link>
	<mat-form-field>
		<input
			autocomplete="email-address"
			matInput
			formControlName="emailAddress"
			type="email"
			placeholder="Email Address"
			required
			maxlength="256"
		/>
		<mat-error *ngIf="form.get('emailAddress').hasError('required')"
			>Required</mat-error
		>
		<mat-error *ngIf="form.get('emailAddress').hasError('email')">
			Invalid email address.
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input 
			matInput
			formControlName="name"
			type="input"
			maxlength="256"
			placeholder="Name"
			required
		/>
	</mat-form-field>
</ng-container>
